import React, { useEffect, useState } from "react";
import { Panel, PanelHeader, PanelBody, PanelFooter } from "./../../components/panel/panel.jsx";
import _ from "lodash";
import moment from "moment";

import { formatDate, formatMoney, formatDate2Iso, momentObj } from "../../helper/formatter.js";
import { useSelector } from "react-redux";

const Excel = require("exceljs");

const Remasur = () => {
    const [file, setFile] = useState();
    const [invoiceArr, setInvoiceArr] = useState([]);
    const [canSave, setCanSave] = useState(false);
    const tercero = useSelector((state) => _.groupBy(state.tercero.items, "registro"));

    const saveFile = (e) => {
        setFile(e.target.files[0]);
    };

    const handleImport = () => {
        if (!file) return;
        setInvoiceArr([]);

        const wb = new Excel.Workbook();
        const reader = new FileReader();

        reader.readAsArrayBuffer(file);
        reader.onload = () => {
            const buffer = reader.result;
            wb.xlsx.load(buffer).then((workbook) => {
                let sheet = workbook.worksheets[0];
                sheet.eachRow((row, rowNumber) => {
                    if (rowNumber == 1) return;
                    let invoice = {
                        itemNumber: rowNumber,
                        fecha_emision: moment(
                            `${row.getCell("B").value}/${row.getCell("C").value}/${row.getCell("D").value}`,
                            "DD/MM/AAA"
                        ).toISOString(),
                        correlativo: parseInt(row.getCell("A").value) || 0,
                        nrc: row.getCell("H").value,
                        razonsocial: row.getCell("E").value,
                        suma: row.getCell("Z").value,
                        iva: row.getCell("AA").value,
                        retencion: row.getCell("AB").value || 0,
                        importe: row.getCell("AC").value,
                        detalle: [
                            {
                                cantidad: row.getCell("L").value ? 1 : null,
                                descripcion: row.getCell("K").value,
                                precio_unitario: row.getCell("L").value,
                                venta: row.getCell("L").value,
                                linea: 0,
                                tipoVentaId: 1,
                            },
                            {
                                cantidad: row.getCell("N").value ? 1 : null,
                                descripcion: row.getCell("M").value,
                                precio_unitario: row.getCell("N").value,
                                venta: row.getCell("N").value,
                                linea: 1,
                                tipoVentaId: 1,
                            },
                            {
                                cantidad: row.getCell("P").value ? 1 : null,
                                descripcion: row.getCell("O").value,
                                precio_unitario: row.getCell("P").value,
                                venta: row.getCell("P").value,
                                linea: 2,
                                tipoVentaId: 1,
                            },
                            {
                                cantidad: row.getCell("R").value ? 1 : null,
                                descripcion: row.getCell("Q").value,
                                precio_unitario: row.getCell("R").value,
                                venta: row.getCell("R").value,
                                linea: 3,
                                tipoVentaId: 1,
                            },
                            {
                                cantidad: row.getCell("T").value ? 1 : null,
                                descripcion: row.getCell("S").value,
                                precio_unitario: row.getCell("T").value,
                                venta: row.getCell("T").value,
                                linea: 4,
                                tipoVentaId: 1,
                            },
                            {
                                cantidad: row.getCell("V").value ? 1 : null,
                                descripcion: row.getCell("U").value,
                                precio_unitario: row.getCell("V").value,
                                venta: row.getCell("V").value,
                                linea: 5,
                                tipoVentaId: 1,
                            },
                            {
                                cantidad: row.getCell("X").value ? 1 : null,
                                descripcion: row.getCell("W").value,
                                precio_unitario: row.getCell("X").value,
                                venta: row.getCell("X").value,
                                linea: 6,
                                tipoVentaId: 1,
                            },
                        ],
                        status: tercero[row.getCell("H").value],
                    };
                    invoice.detalle = _.reject(invoice.detalle, (v) => v.descripcion == null);

                    setInvoiceArr((oldArray) => [...oldArray, invoice]);
                });
            });
        };
    };

    const registrarComprobanteHanlder = async () => {
        console.log(tercero);
        _.each(invoiceArr, async (invoice) => {
            let payload = {
                fecha_emision: formatDate2Iso(invoice.fecha_emision),
                fecha_vencimiento: momentObj(invoice.fecha_emision).add(30, "days").toISOString(),
                cancelado: false,
                anulado: false,
                n_comprobante: invoice.correlativo,
                suma_venta_sujeta: parseFloat(invoice.suma).toFixed(2),
                suma_venta_excenta: 0,
                suma_venta_no_sujeta: 0,
                iva: parseFloat(invoice.iva).toFixed(2),
                retencion: parseFloat(invoice.retencion).toFixed(2),
                importe: parseFloat(invoice.importe).toFixed(2),
                pendiente: parseFloat(invoice.importe).toFixed(2),
                dias_credito: 30,
                terceroId: tercero[invoice.nrc][0].id,
                is_compra: false,
                is_venta: true,
                talonarioId: 12,
                detalle_comprobantes: invoice.detalle,
            };

            const comprobanteRes = await fetch("/api/comprobante/registrar", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });

            if (comprobanteRes.ok) {
            } else {
                throw Error(await comprobanteRes.text());
            }
        });

        alert("comprobantes registrados");
    };

    useEffect(() => {
        if (invoiceArr.length > 0) {
            let x = _.find(invoiceArr, ["status", false]);

            let canSave = true;
            _.each(invoiceArr, (e) => {
                if (!e.status) canSave = false;
            });
            setCanSave(canSave);
        }
    }, [invoiceArr]);

    return (
        <div>
            <div className="row mb-3">
                <div className="col-xl-12">
                    <Panel>
                        <PanelHeader>Cargar Facturas: </PanelHeader>

                        <PanelBody>
                            <div className="row">
                                <h3>Archivo de facturas</h3>

                                <div className="row justify-content-md-center mb-3">
                                    <div className="col-md-6 col-12">
                                        <input
                                            className="form-control"
                                            type="file"
                                            accept="*"
                                            onChange={saveFile}
                                            name="invoice"
                                        />
                                    </div>
                                </div>

                                <div className="col-md-12 text-center ">
                                    <button className="btn btn-inverse btn-lg ms-5px mb-2" onClick={handleImport}>
                                        <i className="fas fa-upload fa-fw"></i> cargar archivo de facturas
                                    </button>
                                </div>
                            </div>

                            <hr />

                            <div className="table-responsive">
                                <table className="table table-bordered widget-table align-middle rounded table-sm table-hover table-striped">
                                    <thead>
                                        <tr className="text-nowrap">
                                            <th>Fecha</th>
                                            <th>Correlativo</th>
                                            <th>NRC</th>
                                            <th>Razon social</th>
                                            <th>suma</th>
                                            <th>iva</th>
                                            <th>retencion</th>
                                            <th>Importe</th>
                                            <th>Verificacion</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {_.map(invoiceArr, (item, i) => {
                                            return (
                                                <tr key={i}>
                                                    <td className="text-nowrap">{formatDate(item.fecha_emision)}</td>
                                                    <td className="text-nowrap">{item.correlativo}</td>
                                                    <td className="text-nowrap">{item.nrc}</td>
                                                    <td className="text-nowrap">{item.razonsocial}</td>
                                                    <td className="text-nowrap">{formatMoney(item.suma)}</td>
                                                    <td className="text-nowrap">{formatMoney(item.iva)}</td>
                                                    <td className="text-nowrap">{formatMoney(item.retencion)}</td>
                                                    <td className="text-nowrap">{formatMoney(item.importe)}</td>
                                                    <td className="text-nowrap">
                                                        {item.status ? "OK" : "-->>Cliente no registrado!!"}
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </PanelBody>

                        <PanelFooter>
                            <button onClick={registrarComprobanteHanlder} className="btn btn-green" disabled={!canSave}>
                                <span className="d-flex align-items-center text-start">Guardar Comprobantes</span>
                            </button>
                        </PanelFooter>
                    </Panel>
                </div>
            </div>
        </div>
    );
};

export default Remasur;
